export default {
  line: "Хат",
  language: "Забон",
  common: [
    "Хизматрасониҳои онлайн",
    "Бекор кардани боздошт",
    "Оё барои харид 10,000 TJS сарф кардан лозим аст!"
  ],
  informationHub: "Хаби расмии SGM.s",
  charitables: [//慈善
    "Хуш омадед ба маркази расмии иттилоотии SGM.s! 🌟 Платформаи шумо барои маълумоти шаффоф ва боэътимод. Дар ин ҷо шумо метавонед сертификатҳои расмии сертификатсияи моро 📜 санҷед, барои маълумоти муфассал ба https://sgm.lol/ муроҷиат кунед 🌐 ва барои навсозиҳои охирин ба канали Telegram-и мо пайравӣ кунед! 📲 Илова бар ин, шумо шарҳҳои мусбати SGM.s-ро аз расонаҳои байналмилалӣ ба монанди Yahoo, The Associated Press ва Google хоҳед ёфт! 📰 Ҳамаи ин эътимоди шуморо ба бренди SGM.s ва рушди ояндаи он ба таври назаррас афзоиш медиҳад ва ба шумо дар муваффақият дар тиҷорати муштараки мобилӣ ва ба даст овардани даромади иловагии назаррас кӯмак мекунад! 📲 Илова бар ин, шумо шарҳҳои мусбати SGM.s-ро аз расонаҳои байналмилалӣ ба монанди Yahoo, The Associated Press ва Google хоҳед ёфт! 📰 Ҳамаи ин эътимоди шуморо ба бренди SGM.s ва рушди ояндаи он ба таври назаррас афзоиш медиҳад ва ба шумо дар муваффақият дар тиҷорати муштараки мобилӣ ва ба даст овардани даромади иловагии назаррас кӯмак мекунад! 💰🚀"
  ],
  details: [
    "Нархи воҳиди вазифа",
    "Шумораи фармоиш",
    "Даромади ҳаррӯза",
    "сатҳ",
    "Фоидаи ҳаррӯза",
    "Гузаронидан",
    "Санаи баргардонидани пасандоз",
    "рӯзҳои боқимонда",
    "Сатҳи SGM.s-и ман"
  ],
  upload: [
    "Боргузорӣ...",
    "Формати нодуруст",

    "Бомуваффақият боргузорӣ шуд",

    "Боргузорӣ ноком шуд"
  ],
  vanPull: [
    "Маълумоти дигар нест",
    "Маълумот нест"
  ],
  login: {
    title: 'Бо истифода аз корбар ва парол ворид шавед',
    title_txt: 'Бо истифода аз рақами телефони мобилии бақайдгирифташудаи худ ворид шавед',
    text: [
      "Номи корбар/паролро дар хотир нигоҳ доред",
      "Сабткунӣ...",
      "Ҳоло ворид шавед"
    ],
    placeholder: [
      "Лутфан рақами телефонро ворид кунед",
      "Лутфан пароли воридшавиро ворид кунед"
    ],
    i18n: [
      "Ҳисоби {title} вуҷуд надорад? {a} {line}",
      "Бақайдгирӣ"
    ],
    serve:[
      "Бо сиёсати махфияти мо ё шартҳои сервер розӣ шавед"
    ]
  },
  register: {
    text: [
      "Хуш омадед ба сабти ном",
      "Рамзи SMS фиристода мешавад...",
      "Гирифтани рамзи SMS",
      "Бақайдгирӣ...",

      "Ҳоло сабти ном",
      "Албатта ҳисоб доред? Ҳоло ворид шавед",
      "Бақайдгирии рақами телефони мобилӣ",
      "Бақайдгирии почтаи электронӣ",
      "Бозгашт ба воридшавӣ",
      "Лутфан, рақами телефони бақайдгирифтанашуда ва суроғаи почтаи электрониро истифода баред"
    ],
    placeholder: [
      "Лутфан рақами телефони худро ворид кунед",
      "Лутфан рамзи тасдиқи SMS-ро ворид кунед",

      "Лутфан пароли воридшавиро ворид кунед",

      "Лутфан пароли худро тасдиқ кунед",

      "Лутфан рамзи даъватномаро ворид кунед",

      "Ду парол гуногунанд",

      "Лутфан рамзи тасдиқро ворид кунед",

      "Лутфан рақами почтаи электрониро ворид кунед",

      "Бо 0 оғоз кардан мумкин нест"
    ],
    i18n: [
      "Ҳисоб доред? {a} {line}",
      "Воридшавӣ"
    ]
  },
  home: {
    lucky: "Чорабинӣ ҳанӯз кушода нашудааст",
    map: "Макон",
    qywh: "Фарҳанги корпоративӣ",
    broadcast: "Табрикот ба {member} барои даъват кардани дӯстатон барои ҳамроҳ шудан ба барномаи онлайнӣ оид ба мубодилаи дучархаҳои SGM, пешбарӣ шудан ба {vipname} ва гирифтани мукофотҳои мубодилаи {grade}.",
    menu: [
      "Минтақаи VIP",
      "Дарси видеоӣ",

      "Мукофотҳои таблиғотӣ"
    ],
    taskHall: {
      title: [
        "Толори вазифаҳо",
        "Толори тиҷорат",

        "Иҷрои вазифаҳо барои ба даст овардани фоида"
      ]
    },
    title: ['Вазифа', 'Хабарҳо', 'бештар', 'кушодан', 'Лутфан, кушоданро оғоз кунед ва истифодабариро идома диҳед~', 'Санҷиш', 'Табрик! Навсозӣ бомуваффақият анҷом ёфт', 'Табрик~ ду корти партофташуда гирифтам'],
    memberList: {
      title: "Рӯйхати аъзоён",
      data: [
        "{member}, супоришҳои фармоиши имрӯзаи {num}-ро иҷро кунед!"
      ]
    },
    businessList: {
      title: "Рӯйхати тоҷирон",
      data: [
        "{member}",
        "Имрӯз {num} вазифаи ягонаро раҳо кунед"
      ]
    },
    noticeTitle: ["Огоҳӣ", "Қаблӣ", "Баъдӣ"],
    tabBar: ["Хона", "Интиқол", "Т", "Харита", "Ман"],
    msg: "Вазифа кушода нест",
    video: "Дарси видеоӣ нест",
    message: "Шумо хабарҳои нав доред",
    bonus: [
      '<p>Барои гирифтани мукофоти пулии "Рамзи велосипедронӣ" (1-200000 TJS) рамзро ворид кунед</p><p>1. "Рамзи велосипедронӣ" тавассути фаъолиятҳои ширкат ба даст оварда мешавад!</p><p>2. SGM паролро давра ба давра нашр мекунад! Лутфан, навсозиҳоро ҳар рӯз тафтиш кунед!</p><p>Дучархаҳоро истифода баред, аз ҳаёти иқтисодии муштарак лаззат баред ва ба осонӣ мукофотҳои пулии рамзро гиред!</p><p>Барои тафсилот, лутфан бо "Менеҷери бозор" машварат кунед</p>',
      'Рамз тавассути фаъолиятҳои ширкат ба даст оварда мешавад!',
      'Рамзи лифофаи сурхро ворид кунед',
      'Пул гиред',
      'Табрикот барои бурди Ride Cash {amount}TJS',
      'Ride Cash'
    ],
    helpCenter: {
      title: "Маркази кӯмак",
      empty: "Мақолаҳои кӯмак нест"
    }
  },
  vip: {
    title: [
      "Сатҳи VIP",
      "Барои гирифтани вазифаҳо ҳоло ба узвият ҳамроҳ шавед",

      "Дар ҳоли таҳия"
    ],
    user: {
      title: [
        "Шахсияти шумо",
        "Меҳмонон"
      ],
      label: "Вазифаҳои ҳаррӯза",
      value: [
        "Санаи эътибор пайдо кардан",
        "Як сол",

        "Лутфан, аввал ворид шавед",

        "Мӯҳлати амали таҷрибаомӯзӣ",

        "Шумораи баргардонидани пасандоз",

        "Шумораи эътибор пайдо кардани сатҳи VIP"
      ],
    },
    list: {
      label: "Фармоиши ҳаррӯза:{number}",
      button: "Ҳоло ҳамроҳ шавед",
      text: [
        "Фоидаи ҳаррӯза",

        "Даромади моҳона",

        "Ҷалбкунӣ барои кор: Ҳама",

        "Рохӣ",

        "Барои ҳар як фармоиш",

        "Даромади рейтингӣ",

        "Бозгашти муассир",

        "Санаи анҷом",

        "Сол",

        "Рӯз",

        "Мӯҳлати эътибор"
      ],
    },
    dialog: [
      "Оё шумо мутмаин ҳастед, ки барои {name} шудан {current} {amount} сарф мекунед?",
      "Шумо айни замон {currname} ҳастед ва наметавонед {name} бошед",
      "Оё шумо мутмаин ҳастед, ки барои навсозии {name} {current} {amount} сарф мекунед?",
    ],
    index: ["Бекор кардан", "Тасдиқ кунед"],
    desc: [
      'Имтиёзҳои {level}',
      'Даромади асосӣ',
      'Вақт',

      'Шумораи таҳвил',

      'Даромад',

      'Ҳаррӯза',

      'Моҳона',

      'Солона',

      'Даромади ҷалб',//8
      'Сатҳи зербахш',

      'Нишондиҳандаи комиссияи ҷалб',
      'Мукофотпулии ҷалб',
      'Захираи сатҳи 1',

      'Захираи сатҳи 2',

      'Захираи сатҳи 3',
      'Тахфифи таҳвили якрӯза',
      'Сатҳи зербахш',

      'Нишондиҳандаи тахфифи таҳвили зербахш',//17
      'Маблағи тахфифи таҳвил',
      'Захираи сатҳи 1',
      'Захираи сатҳи 2',

      'Захираи сатҳи 3',

      '3 рӯз',

      'Нархи воҳиди таҳвил',

      'Тафсилоти давраи санҷиш',//24
      'Озмоиш: Харид лозим нест. Дучархаҳои муштаракро дар як рӯз ду маротиба ҷойгир кунед, ки комиссияи 3 сомонӣ барои як ҷойгиркунӣ, ҳамагӣ 6 сомониро дар як рӯз ташкил медиҳад. Озмоиши ройгон барои 2 рӯз.',
      'Намунаи комиссияи вазифа:',
      '<p>Шарикони сатҳи 1, ки дар як рӯз фармоишҳои саворӣ ба маблағи 10,000 TJS иҷро мекунанд, комиссияи 300 TJS мегиранд.</p><p>Шарикони сатҳи 2, ки дар як рӯз фармоишҳои саворӣ ба маблағи 10,000 TJS иҷро мекунанд, комиссияи 200 TJS мегиранд.</p><p>Шарикони сатҳи 3, ки дар як рӯз фармоишҳои саворӣ ба маблағи 10,000 TJS иҷро мекунанд, комиссияи 100 TJS мегиранд. </p>',
      'Тавсифи бонуси тавсия:',
      '<p>(Тобеи сатҳи 1) Шумо мустақиман А-ро барои ҳамроҳ шудан даъват мекунед, А тобеи сатҳи 1-и шумост.</p><p>(Тобеи сатҳи 2) А Б-ро барои ҳамроҳ шудан даъват мекунад, Б тобеи сатҳи 2-и шумост.</p><p>(Тобеи сатҳи 3) Б С-ро барои ҳамроҳ шудан даъват мекунад, С тобеи сатҳи 3-и шумост.</p><p>Эзоҳ: Бонуси тавсия танҳо барои баландтарин бонуси сатҳи ҷории шахс талаб карда мешавад.</p>',
    ]
  },
  charitable: [
    'ПЛАТФОРМИ ҶАҲОНИИ SGM',
    'Амиқсозии табдили маркетинги рақамӣ, мусоидат ба риояи қонунҳо дар Осиёи Марказӣ ва бунёди озодии молиявӣ якҷоя бо як дастаи баландсифат.',
    'Иқтисоди рақамии гиг ва матритсаи краудсорсинги ҷаҳонӣ ба давраи дивидендҳои сохторӣ ворид мешаванд. Дар бозорҳои рӯ ба инкишоф, махсусан дар Осиёи Марказӣ (бо Тоҷикистон ҳамчун минтақаи асосӣ), аз ҷониби аҳолии бузурги корӣ талаботи таркишӣ ва сахт барои шуғли чандири онлайн бо монеаҳои ҳадди ақал барои воридшавӣ ва фоидаи баланд вуҷуд дорад.',
    'Тавассути технологияҳои беназири "Барқарорсозии арзиши шабакаи шахсӣ" ва "Тақсимоти вазифаҳои рақамӣ", мо вақти фароғатии ҳар як шахсро ба дороиҳои устувори иқтисодӣ табдил медиҳем ва ба даҳҳо ҳазор оилаҳо дар ноил шудан ба беҳбудиҳои куллӣ дар шароити зиндагии худ кӯмак мерасонем.',
    'Мо шуморо ташвиқ мекунем, ки дар ташаббусҳои хайрияи ҷамъиятӣ фаъолона иштирок кунед ва якҷоя бигзоред, ки муҳаббат ва сабз дар ҳар гӯшаи шаҳр шукуфон шаванд..',
    'Ҳуҷҷати сафеди расмии тиҷорати v2.7.1'
  ],
  lucky: {
    default: [
      "Педали хушбахтона",
      "Шумораи боқимондаи қуръакашӣ:",
      "Сабти қуръакашӣ",

      "Қоидаҳои лотерея",

      "<p>Дар фаъолиятҳои ширкат иштирок кунед ва имкониятҳои қуръакашии хушбахтонаро ба даст оред!</p>",

      "Сабти корбари бурднок",

      ['Табрик:{member}', 'Ҷоизаҳоро {profit} гиред'],
      "Табрик,Ҷоизаҳоро гиред",

      "пӯшед",

      "Вақтҳои қуръакашии шумо истифода шудаанд",

      "Эътиборнок то"
    ],
    scattered: [
      'Шумораи қуръакашӣ',
      'Савор',
      '<p>1.Шумораи қуръакашӣ тавассути фаъолиятҳои ширкат ба даст оварда мешавад!</p><p>2.Ҳар як қуръакашӣ 1 қуръакаширо сарф мекунад!</p><p>3.Пас аз бурди ҷоизаи ҷисмонӣ, лутфан бо менеҷери ҷалби кормандон тамос гиред, то маълумоти худро сабти ном кунед ва онро гиред!</p>',
      'Ёдраскунӣ',
      'Ёдраскуниҳои муҳим',
      'Ҳуқуқи қуръакашӣ',
      'Имкониятҳои қуръакаширо тавассути фаъолиятҳои ширкат ба даст оред',

      'Қоидаҳои қуръакашӣ',
      '1 қуръакашӣ барои ҳар як кӯшиш сарф мешавад',
      'Барои гирифтани ҷоизаҳои ҷисмонӣ бо менеҷери ҷалби кормандон тамос гиред'

    ],
    prizeList: [
      'Ҳавзи ҷоизаи Pedal Lucky',
      'TJS52 пули нақд',
      'Гирифтани фаврӣ',
      'TJS88 пули нақд',
      'TJS205 пули нақд',
      'TJS19,889 пули нақд',
      'TJS236,666 пули нақд',
      'Телефони Android',
      'Ба маблағи TJS8,000',
      'Ваучери навсозӣ',
      'Арзиши TJS600',
      'Фармоишҳои дукарата',
      'Ҳаррӯза',
      'Пули барқии истисноии ширкати SGM.s',
      'ба маблағи TJS1,000',
      'Дучархаи механикӣ',
      'Ба маблағи TJS3,000',
      'Мопедҳои электронӣ',
      'Ба маблағи TJS80,000',

      'iPhone 17',
      'Ба маблағи TJS160,000'
    ],
  },
  moments: [
    'Навсозиҳои ҳаррӯза',
    'Платформаи расмӣ барои кормандони SGM.s барои мубодилаи даромад аз истифодаи велосипед, фаъолиятҳои хайриявӣ ва лаҳзаҳои аҷиб. Барои иштирок дар қуръакашии ҷоизаҳои пулӣ (1-200,000 TJS), Daily-ро барои 3 рӯзи пайдарпай навсозӣ кунед. Ба ҳамдастагон дар паҳн кардани муҳаббат ва пурарзиштар кардани ҳар як саворӣ ҳамроҳ шавед!'
  ],
  userLc: {
    default: [
      "Сарвати даврӣ",
      "Сабтҳо",

      "Маблағ",

      "Давраи нигоҳдорӣ",

      "Маблағи пасандоз",
      "Лутфан, маблағи пасандозро ворид кунед",

      "Даромад",

      "Фиристодан",//7
      "Лутфан, аввал маҳсулотро интихоб кунед",

      "Лутфан, маълумотро интихоб кунед",

      "Фоида",

      "Рӯз",

      "маълумот нест",

      "Вақти харид",
      "ҳолат",

      "Вақти анҷом",

      "Бақия",

      "Даромади имрӯза",

      "Хариди як клик"//18
    ],
    tabs: [
      "Рӯйхати маҳсулот",
      "Сабти пасандозҳо"
    ],
    buyTimes: {
      once: "Танҳо як бор харидан мумкин аст",
      renew: "Хариди дубора пас аз хатми давра",
      multi: "Бисёр бор харидани дубора"
    },

    tips: '<p>VOISP "Wealth Enhance" роҳи ширкат барои фароҳам овардани роҳҳои бештари афзоиши даромади онҳо ба ҳамаи кормандони сатҳи M мебошад. Лоиҳаҳои сармоягузорӣ лоиҳаҳои сармоягузории молиявӣ мебошанд, ки аз ҷониби PAGE, бонкҳо, ширкатҳои идоракунии дороиҳо ва ғайра якҷоя оғоз карда мешаванд!</p><p>Сармоягузории кӯтоҳмуддат: даромади устувор, интихоби давраи чандир! Фондҳои бекори кӯтоҳмуддат метавонанд тавассути сармоягузорӣ даромади иловагӣ ба даст оранд!Сармоягузории дарозмуддат: Фоидаи баландтар, афзоиши пасандозҳои мунтазами хуби сармоягузорӣ, доштани фоидаи баландтар ва амалӣ кардани орзуҳои худ тавассути ҷамъоварӣ!</p>'
  },
  newlist: {
    text: [
      "Сабтҳо нестанд",
      "Даромади интизорӣ",

      "натиҷаҳо",

      "вақтро харед",

      "ҳолат",

      "Анҷоми вақт"
    ],
    placeholder: [
      "маълумот дигар нест",
      "маълумот нест"
    ],
    i18n: [
      "Таърихи харид",
    ],
    title: [
      "Нақшаи пасандозҳои сабзи велосипедронӣ — имтиёзи махсус, ки махсус барои кормандони пурравақти SGM.s тарҳрезӣ шудааст!",
      "Маблағҳои шумо аз ҷониби муассисаҳои молиявӣ, ба монанди кассаҳои амонатӣ назорат ва ваколатдор карда мешаванд ва 100% бехатар ва боэътимод мебошанд. SGM.s бо бисёре аз бонкҳои пешқадам ҳамкорӣ мекунад, то навъҳои гуногуни маҳсулоти пасандозиро бо шартҳои тағйирпазир ва даромадҳои гуногун барои расидан ба ҳадафҳои молиявии шумо дар ҳама марҳилаҳо таъмин намояд.",
      "Мо на танҳо шуморо ташвиқ мекунем, ки дар ҷойгиркунии велосипед фаъолона иштирок кунед ва сафари камкарбонро қабул кунед, балки умедворем, ки шумо молияи шахсии худро оқилона ба нақша мегиред ва дар айни замон ба ояндаи сабзтар саҳм мегузоред. SGM.s ифтихор дорад, ки дар баробари шумо қадам мезанад, зеро мо боби наверо дар сарвати сабз якҷоя мекушоем!"
    ]
  },
  product: {
    default: [
      "Бақияи ҳисоби таблиғотӣ",
      "Маблағи ибтидоии пасандоз",

      "Маблағи ҳадди аксар пасандоз",

      "Давра",

      "Меъёри фоизи ҳаррӯза",

      "ҳадди аксар",

      "Қоидаҳои лоиҳа",

      "Маблағи лоиҳа",

      "Усули пардохт",

      "Маблағи ибтидоии пасандоз",

      "Фоидаи ҳаррӯза",

      "Давраи барориш",

      "Даромади тахминӣ"
    ],
    investRange: "Диапазони маблағи сармоягузорӣ",
    placeholder: [
      "Баргардонидани қарзи асосӣ ва даромад пас аз ба охир расидан (дар рӯзҳои ид муқаррарӣ)",
      ", ҳисоббаробаркунии худкор дар давоми 24 соат",
      "{str} = даромади умумӣ {income} {currency} + асосӣ {money} {currency} =ҷамъи асосӣ ва фоиз {total} {currency}",
      "Пароли амниятӣ"
    ]
  },
  user: {
    vipl: "Сатҳи шарик",
    hello: "бозгашт муборак",
    default: [
      "Роҳбари ман",
      "Ҳисоб",
      "Рамзи даъват",
      "Баромадан аз вуруд",
      "Бақия",
      "Тилло",
      "Ҳамёни ман",
      "Мӯҳр",
      "Маҳдудият",
      "Хуб",
      "Аъло",
      "Фаъолсозии 'Ёвари хониш'",
      "Тамос бо менеҷери кироя",
      "Хароҷоти амалиётӣ"
    ],
    myEarnings: {
      grid: ["Бақия", "Даромади дирӯз", "Даромади имрӯза", "Даромади ин ҳафта", "Даромади ин моҳ", "Даромади моҳи гузашта", "Даромади умумӣ", "Иҷрои вазифа имрӯз (PCE)", "Супоришҳои боқимондаи имрӯза (PCE)", "Комиссияи имрӯза", "Тахфифи интиқол", "Тахфифи муроҷиат"]
    },
    grid: [
      "Бақия",
      "Даромади дирӯз",
      "Даромади имрӯза",
      "Даромади ин ҳафта",
      "Даромади ин моҳ",
      "Даромади моҳи гузашта",
      "Даромади умумӣ",
      "Иҷрои вазифа имрӯз (PCE)",
      "Супоришҳои боқимонда имрӯз (PCE)",
      "Комиссияи имрӯза",
      "Тахфифи имрӯза"
    ],
    menu: [
      "Сабтҳои вазифаҳо",
      "Вазифаи аудит",
      "Идоракунии озодкунӣ",
      "Маълумоти шахсӣ",//3
      "Бастани ҳисоб",
      "Ҳисоботи ҳаррӯза",
      "Сабтҳои муҳосибӣ",//6
      "Даъватномаи муштарак",
      "Ҳисоботҳои даста",//8
      "Дастури кӯмак",//9
      "Арзёбии даста",//10
      "БАРНОМАРО зеркашӣ кунед",//11
      "Педали хушбахт",//12
      "Сарвати велосипедронӣ",
      "Ёвари хониш",
      "Фарҳанги корпоративӣ",
      "Видеои корпоративӣ",
      "Дастаи аъло",
      "Сарвати велосипедронӣ",
      "SGM.s-ро пайгирӣ кунед",
      "Мукофотҳои рушд",
      "Рамзи велосипедронӣ",
      "Педали амалҳо",
      "Шаҳодатномаи SGM",//23
    ],
    positions: [
      "Вазифаи ман",
      "Вазифаи кунунӣ",
      "Вазифаи навбатӣ",
      "Узви сатҳи M, ки мустақиман бо он алоқаманд аст",
      "Узви дастаи M сатҳи 3",
      "Дастаи сатҳи 3 (шумораи {post})",
      "Ҳамаи талаботро барои тамос бо менеҷери кироя барои пешбурди вазифаи худ иҷро кунед!",
      "Тавсифи вазифа",
      "Дархости вазифа",
      "Тавсифи кор"
    ],
    office: [
      "Маълумот дар бораи кори ман",
      "Тафсилоти пешравии кор",
      "Тавсифи кори SGM.s",
      "Вазифаи корпоративӣ",
      "Пешравии кор",
      "гирифтан",
      "Раванди пешравии кор",
      "Ҳадди ақал ",
      "Шартҳо риоя нашудаанд",//8
      "Ҳисоботдиҳандагони мустақим бояд {num} велосипед фурӯшанд.",
      "Аъзоёни даста бояд {num} велосипед фурӯшанд.",
      " аъзо дошта бошад",
      "Гирифта шудааст",//12
      "Боргузории тасвири шиноснома лозим аст",//13 需上传身份审核
      "Ҳар моҳ дар рӯзи {day} гирифтан мумкин аст"//14 每月{day}号可领取
    ],
    current: [
      "Вазифаҳои кунунӣ",
      "Шумораи умумии аъзоёни VIP"
    ],
    subordinate: [
      "Сатҳи 1",
      "Сатҳи 2",

      "Сатҳи 3",

      "рӯйхати аъзоён",
      "шумораи умумии одамон",
      "Даромади умумӣ",

      "Маблағи гирифтани маблағ",
      "Даромади даста",
      "Рӯйхати аъзоён",

      "корбар",

      "сатҳ",

      "Вақти ҳамроҳшавӣ",
      "Давраи озмоишӣ"
    ],
    follow: [
      "Канали расмии SGM.s-ро",
      "Барои гирифтани маълумоти бештар дар бораи охирин маълумоти SGM.s, каналро пайгирӣ кунед!"
    ]
  },
  userInfo: {
    default: [
      "Маълумоти шахсӣ",
      "Портрети сар",

      "Рақами мобилӣ",

      "Илова кардани суратҳисоби бонкӣ",

      "Alipay",

      "Номи воқеӣ",

      "Пароли вуруд",

      "Пароли фонд",
      "Танзимотро клик кунед",
      "Тағйир додани портрети сар",
      "Тағйир додани пароли вуруд",

      "Тағйир додани пароли фонд",
      "Ирсол",

      "Хол кардани кэш",
      "Баромадан"
    ],
    label: [
      "Пароли аслии воридшавӣ",
      "Пароли нави воридшавӣ",
      "Тасдиқи паролҳо",
      "Рамзи аслии пул",
      "Рамзи нави пул",
      "Паролро тасдиқ кунед"
    ],
    placeholder: [
      "Лутфан, пароли аслии воридшавиро ворид кунед",
      "Лутфан, пароли нави воридшавиро ворид кунед",

      "Лутфан, пароли воридшавиро тасдиқ кунед",

      "Лутфан, пароли аслии фондро ворид кунед",

      "Лутфан, пароли нави фондро ворид кунед",

      "Лутфан, пароли фондро тасдиқ кунед"
    ]
  },
  userSet: {
    default: [
      "Сертификатсияи номи воқеӣ",
      "Маълумоти муфассал",

      "Бастани Alipay",

      "Ирсол"
    ],
    label: [
      "Номи аслӣ",
      "QQ",
      "Ҳисоби Alipay",
      "Номи Alipay"
    ],
    placeholder: [
      "Лутфан номи ҳақиқиро ворид кунед (Номи ман барои гирифтани пули нақд истифода мешавад)",
      "Рақами QQ-ро ворид кунед",
      "Лутфан ҳисоби Alipay-ро ворид кунед",
      "Лутфан номи Alipay-ро ворид кунед"
    ],
    tips: "Ёдраскунӣ: Корти бонкии басташударо тағир додан мумкин нест, он барои гирифтани маблағ истифода мешавад"
  },
  bindAccount: {
    default: [
      "Ҳисобро пайваст кунед",
      "Дидани дастур",

      "Ирсол"
    ],
    tabs: [
      "Ҳисоб",
      "Ҳисоб",
      "Ҳисоб"
    ],
    label: [
      "Дастурҳо",
      "Илова кардани скриншот",

      "Ҳисоб"
    ],
    placeholder: "Лутфан, ҳисоби {account}-и худро ворид кунед"
  },
  bankCard: {
    default: [
      "Корти бонкиро бандед",
      "Ҳоло тасдиқ кунед",

      "Фиристодан ...",

      "Ҳоло илова кунед",

      "Корти бонкиро илова кунед"
    ],
    tips: [
      "Пеш аз илова кардани корти бонкӣ, лутфан тасдиқи номи воқеиро анҷом диҳед",
      "Номи суратҳисоб дар корти бонкии шумо бояд бо номи воқеие, ки шумо тасдиқ кардаед, мувофиқ бошад, вагарна шумо наметавонед пули нақдро бомуваффақият гиред."
    ],
    label: [
      "Ном",
      "Номи бонк",

      "Рақами суратҳисоби бонкӣ",

      "Рамзи филиал",
      "IFSC"
    ],
    placeholder: [
      "Лутфан номи бонкро интихоб кунед",
      "Лутфан рақами суратҳисоби бонкиро ворид кунед",

      "Лутфан рамзи филиалро ворид кунед",

      "Тасдиқ кунед",

      "Бекор кунед",

      "Лутфан IFSC-ро ворид кунед"
    ]
  },
  wallet: {
    default: [
      "Ҳамёни ман",
      "Пур кардани маблағ",
      "Гирифтани маблағ",
      "Сабти пур кардани маблағ",
      "Сабти бозхондани маблағ",
      "R",

      "W",
      "₽ пур кардани маблағ"
    ],
    label: [
      "Усули гирифтани маблағ",
      "Маблағи гирифтани маблағ",

      "Рамзи маблағ",

      "Фиристодан",

      "Рақами телефон",

      "Почтаи электронӣ",

      "IFSC",

      "Усули пардохт",

      "Андозбандӣ",

      "Маблағи воқеии гирифташуда"
    ],
    placeholder: [
      "Усули гирифтани маблағро интихоб кунед",
      "Лутфан маблағи гирифтани маблағро ворид кунед",

      "Лутфан пароли маблағро ворид кунед",

      "Лутфан усули гирифтани маблағро интихоб кунед",

      "Лутфан рақами телефони мобилии гирандаро ворид кунед",

      "Лутфан суроғаи почтаи электронии гирандаро ворид кунед",

      "Лутфан IFSC-и гирандаро ворид кунед",

      "Лутфан усули пардохтро интихоб кунед"
    ],
    msg: [
      "Шумо ҳанӯз пароли фондро муқаррар накардаед, лутфан аввал якеро муқаррар кунед",
      "Шумо ҳанӯз корти бонкии худро пайваст накардаед, лутфан аввал онро пайваст кунед",
      "<p>Вақти гирифтани маблағ:</p><p>Душанбе: M9</p><p>Сешанбе: M8</p><p>Чоршанбе: M6/M7</p><p>Панҷшанбе: M3/M4/M5</p><p>Ҷумъа: M1/M2</p><p>(Коромӯзон аз душанбе то якшанбе)</p><p>аз соати 9 то 18</p>"
    ]
  },
  recharge: {
    default: [
      "Пур кардани маблағ",
      "Тафсилоти пур кардани маблағ",

      "Сабти пур кардани маблағ",

      "Бақияи дастрас {money}, лутфан усули пур кардани маблағро интихоб кунед",

      "Маблағи ҳадди ақали ягона {currency} {min}, ҳадди аксар {currency} {max}, ҳаққи коркард {fee}%",

      "Фиристодан...",
      "Ҳоло пур кардани маблағ",
      "Баргардонидан",

      "Бор кардани...",
      "Маблағи ҳадди ақали ягона ${min}, ҳадди аксар ${max}, ҳаққи коркард {fee}%"
    ],
    label: [
      "Маблағи пардохт",
      "Канали пардохт",

      "Номи интиқол",

      "Номи пардохткунанда",

      "Телефони мобилии пардохткунанда",

      "Ҳисоби UPI-и пардохткунанда",
      "Почтаи электронии пардохткунанда",

      "Фармоиши амалиёт"
    ],
    placeholder: [
      "Лутфан маблағи пуркунии пардохтро ворид кунед",
      "Лутфан канали пуркунии пардохтро интихоб кунед",

      "Лутфан номи интиқолро ворид кунед",

      "Маблағи ҳадди ақали ягона {currency} {min} аст",

      "Маблағи ҳадди аксар ягона {currency} {max} аст",

      "Лутфан номи пардохткунандаро ворид кунед",

      "Лутфан рақами телефони мобилии пардохткунандаро ворид кунед",
      "Лутфан ҳисоби UPI-и пардохткунандаро ворид кунед",
      "Лутфан суроғаи почтаи электронии пардохткунандаро ворид кунед",

      "Лутфан скриншоти интиқолро бор кунед",
      "Лутфан рақами фармоиши амалиётро ворид кунед"
    ],
    info: [
      "Маблағи пуркунӣ",
      "Рақами фармоиш",
      "Бонк",

      "Рақами ҳисоб",

      "Ном",

      "Нусхабардорӣ",
      "Интиқоли {type}",

      "Скриншоти интиқол",
      "Ирсол",

      "Рамзи IFSC",

      "Навъи ҳисоб",

      "Дастурҳои коркард"
    ],
    tips: [
      "Лутфан, усули зеринро барои интиқоли маблағи мувофиқ интихоб кунед, то аз таъхир дар санҷиши молиявӣ пешгирӣ кунед.<br>Пас аз интиқол, лутфан скриншоти интиқолро ҳамчун шаҳодатномаи тасдиқ бор кунед",
      "Ба илова кардани дӯстон лозим нест, рамзи QR-ро скан кунед, то пулро ба ман интиқол диҳед",

      "Лутфан, интиқолро мувофиқи маълумоти зер анҷом диҳед",

      "Маслиҳат: Пас аз пардохти бомуваффақият, лутфан бо хидмати онлайн тамос гиред, то рақами ҳисоби аъзо, маблағи пуркунӣ, рақами фармоиш, рақами ҳисоби амонатгузор, вақти пуркунӣ, ки барои шӯъбаи молиявӣ қулай аст, ки сари вақт маблағ илова кунад.",

      "Эзоҳ: лутфан барои ҳар як интиқол як пардохт пешниҳод кунед",

      "Пас аз интиқол, лутфан скриншоти интиқолро ҳамчун шаҳодатномаи тасдиқ бор кунед",
      "Маслиҳат: Пас аз пардохти бомуваффақият, лутфан тасвири муомилоти бомуваффақиятро бор кунед",
      "<p>Ёдраскунии пуркунӣ: Лутфан, пеш аз пуркунӣ хонед.</p><p>1: Лутфан, мувофиқи ҳисоби охирини пуркунӣ пардохт кунед.</p><p>2: Мӯҳлати амали пардохт 10 дақиқа аст. Лутфан, пардохтро дар давоми 10 дақиқа анҷом диҳед. Агар пардохт пас аз 10 дақиқа анҷом дода нашавад, ҳисоби қабулкунанда беэътибор хоҳад буд. Лутфан, пуркунии охиринро дубора гиред суратҳисоб барои пардохт.</p><p>3: Маблағи интиқол бояд бо маблағи пешниҳодкардаи шумо мувофиқ бошад.</p><p>4: Агар пардохт ноком шавад, лутфан суратҳисоби қабулкунандаи қаблиро захира накунед. Лутфан, барои гирифтани суратҳисоби охирин фармоиши пуркуниро аз нав пешниҳод кунед, вагарна пардохти шумо беэътибор ҳисобида мешавад.</p><p>5: Агар пардохт муваффақ бошад, лутфан Ваучери пардохт мувофиқи зарурат пешниҳод кунед, то тасдиқи саривақтӣ аз ҷониби шӯъбаи молия осон карда шавад.</p>"
    ],
    minPayHint: "Аз {min} TJS камтар пардохт намудан мумкин нест"
  },
  postTask: [
    "унвон",
    "Интихоби тасвир",

    "Расонидан",

    "Лутфан, барои вазифа унвон ворид кунед"
  ],
  task: {
    default: [
      "РӮЙХАТИ ТАҲВИЛ",
      "Талабот ба вазифаҳо",

      "Эҷод кардан",

      "Аудит",

      "Кушодани пайванд",

      "Нусхабардории пайванд",

      "Нархи воҳид",

      "Ирсол",

      "Рад кардан",

      "Оғози хизматрасонӣ",

      "Дар ҳоли иҷро",

      "ОҒОЗИ ҶОЙГИРКУНӢ"
    ],
    tabs: [
      "Иҷро мешавад",
      "Аудит",

      "Анҷом ёфт",

      "Ноком",

      "Бадхоҳӣ",

      "Тарк карда шудааст"
    ],
    msg: "Миссияи имрӯза ба анҷом расид",
    msgSc: "Бомуваффақият қабул карда шуд",
    msgTime: "Пас аз анҷоми шумориши вақт, вазифа ба таври худкор иҷро мешавад ва бастани барвақти он беэътибор хоҳад буд.!",
    info: [
      "Тафсилоти вазифа",
      "Номи вазифа",

      "Бартариҳои вазифа",

      "Тавсифи вазифа",

      "Талабот барои боргузорӣ",

      "Ирсол кардани намуна",

      "Корбар намунаро пешниҳод накардааст",

      "Қайдҳои аудит",

      "Санаи аудит",

      "Ҷониби талабот",

      "Озод кардан",

      "Нусхабардорӣ",

      "Ҷаҳиш",

      "Қадамҳои вазифа",

      "Қадами {index}",

      "Намунаи аудит",

      "Намунаи аудит нест",

      "Боркунии маълумот...",

      "Даст кашидани вазифа",
      "Ирсол кардани вазифаи анҷомёфта",

      "Нашри мундариҷа"
    ],
    index: [
      "Ҳолати кунунӣ",
      'Рейтинги кунунии шумо <i style="color:#1989fa">{currVip}</i><br>аст, ки танҳо метавонад ба вазифаи сатҳи кунунии <i style="color:#1989fa">{currVip}</i> муроҷиат кунад, оё шумо мехоҳед ба сатҳи <i style="color:#dd6161">{vip}</i> ҳамроҳ шавед',
      "Ҳоло ҳамроҳ шавед",
      "Лутфан категорияи вазифаро интихоб кунед",
      "Бекор кунед",
      "Боқимонда",
      "Интиқоли ройгон",
      "Дар ҳоли таҳия"
    ],
    list: [
      "Рӯйхати вазифаҳо",
      "Ҷониби талабот",

      "Боқимонда",

      "Дархост",

      "Қабулкунанда"
    ],
    show: [
      "Тафсилоти вазифа",
      "Вақти харид",

      "Ҳолати интиқол",

      "Нархи иҷора",

      "Вақти интиқол",

      "Ҳисоби вақт барои қабул",

      "Оғози хизматрасонӣ",

      "Рамзгузорӣ",

      "UNKONE"
    ]
  },
  postRecord: [
    "Навсозиҳои ҳаррӯза",
    "Нашр",

    "Ҷамъ",

    "Анҷомёфта",

    "Мӯҳлати ниҳоӣ",

    "Аудит",

    "Бекоркунӣ",

    "Муҳаррирон",

    "Навсозиҳои ҳаррӯза",

    "Қабул",

    "Маркази эълонҳои SGM.s",

    "Маркази иттилоот"
  ],
  dayReport: [
    "Ҳисоботи ҳаррӯза",
    "Даромади умумӣ",

    "Комиссияи ман",

    "Имтиёзҳои комиссияи ман",
    "Таҳвил аз ҷониби зердастон анҷом дода шуд",

    "Имтиёзҳои вазифаҳои зердастон",

    "PCE",

    "30 рӯзи охир",

    "Миқдор",

    "Таҳвил",

    "Зери зердастон",

    "Истеъмол",

    "Сана"
  ],
  fundRecord: {
    default: [
      "Сабтҳои хароҷот",
      "Сабти пуркунии маблағ",
      "Сабтҳои даромад",
      "R",

      "I",

      "E",

      "Сабтҳои гирифтани маблағ",
    ],
    tabs: [
      "Даромад",
      "Хароҷот",

      "Пур кардани маблағ",

      "Гирифтани маблағ"
    ],
    state: [
      'Ҳама',
      'Пур кардани барқ',	//1 recharge
      'Бозпас гирифтани маблағ',	//2 withdrawal
      'Вазифаро нашр кунед',	//3 task
      'Насоси платформавӣ',	//4 pump
      'Тахфиф',	//5 rebate
      'Таҳвил анҷом ёфт',	//6 commission
      'Мукофотҳои фаъолият',	//7 regment
      'Мукофотҳои тавсиявӣ',	//8 spread
      'Навсозӣ',	//9 buymembers
      'Бекор кардани вазифа',	//10 revoke
      'Даромади сармоягузорӣ',	//11 transfer_c
      'Интиқол ба сармоягузорӣ',	//12 transfer_r
      'Даромади дигар', //13 其他
      'Хайрия кунед',	//14
      'Лифофаи сурх',	//15
      'Роботҳои интеллектуалӣ харед',//16
      'Педали хушбахтона',//17
      'Баргардонидани маблағи хариди VIP',//18
    ]
  },
  promote: [
    "Дӯсти беҳтарини шумо",
    "Шуморо барои ҳамроҳ шудан ба {title} даъват кунед",
    "Рамзи тавсия",
    "Рамзи тавсияро нусхабардорӣ кунед",

    "Истиноди даъватномаро нусхабардорӣ кунед",

    "Рамзи QR-ро захира кунед",

    "Ҳавасмандкуниҳои таблиғотӣ",

    "Постерро бомуваффақият захира кунед",//7
    "Постерро захира кардан номуваффақ шуд, лутфан чанд маротибаи дигар кӯшиш кунед ё скриншотро захира кунед",
    "Лутфан скриншот гиред",
    "Постери таблиғотиро захира кунед",
    "Постери таблиғотиро дар телефони худ захира кунед<br>Агар шумо ноком шавед, лутфан чанд маротибаи дигар кӯшиш кунед ё скриншотро захира кунед",

    "Танҳо шарикони расмии SGM.s ҳақ доранд, ки дӯстонро ба ҳамроҳ даъват кунанд!",
    "Сафари муштарак",
    '<p>1. Мукофотҳои муштарак: Бо даъват кардани корбарони нав барои ҳамроҳ шудан ба SGM, мукофотҳои муштарак ба даст оред.</p><p>2. Комиссияҳои фурӯш: Аз фурӯши велосипедҳои муштарак комиссияҳои ҳаррӯза ба даст оред.</p><p>3. Фаъолиятҳои ширкат: Ширкат мунтазам чорабиниҳои гуногуни таблиғотиро, аз ҷумла "Педалҳои хушбахт", "Рамзҳои саворӣ" ва ҷоизаҳои ҷисмониро оғоз мекунад.</p><p>4. Мукофотҳои ҷамъшуда: Ба ширкат дар фурӯш ва иҷораи велосипедҳои муштараки бештар кӯмак кунед, то дар саҳифаи асосии SGM мукофотҳои пулии муайяншударо гиред. Ҳар қадар велосипедҳои муштараки бештарро барои иҷора даъват кунед, мукофот ҳамон қадар баландтар мешавад.</p><p>5. Вазифаҳои ширкат: Пас аз он ки шумо шумораи муайяни велосипедҳои муштарак доред, шумо метавонед барои вазифаи фурӯш дар дохили ширкат, ба монанди вазифаҳои сатҳи 1, сатҳи 2, сатҳи 3 ва маркетинги идоракунӣ муроҷиат кунед ва маоши иловагии моҳона гиред.</p><p>Ҳар як велосипеди истифодашуда як қадам ба сӯи озодии молиявӣ аст; ҳар як саворӣ ба коҳиш додани партовҳои шаҳрӣ мусоидат мекунад. SGM ба шумо дар расидан ба озодии молиявӣ ҳангоми қабули тарзи ҳаёти сабз кӯмак мекунад.</p>',
    "Сафари муштараки даста"
  ],
  teamReport: {
    default: [
      "Ҷустуҷӯ",
      "Бақияи даста",

      "Имтиёзҳои даста",

      "Пур кардани маблағ аз ҳисоби даста",

      "Хуруҷи даста",

      "Шумораи пардохтҳои аввал",

      "Шумораи теладиҳии аввал",

      "Андозаи даста",

      "Дастаи нав",
      "PCE",
      "Ман",
      "Истифодабаранда",

      "Пур кардани маблағ",

      "Баргардонидан",

      "Комиссия",

      "Санаро интихоб кунед",

      "Маълумот нест",
      "Маблағи пардохтҳо",
      "Шумораи пардохтҳо",
      "Баргардонидани маблағ аз ҳисоби гирифташуда",

      "Шумораи пардохтҳои даста",//21
      "Шарики даста",

      "Даромади умумии тавсияшуда",
      "Даромади умумӣ аз пардохтҳои интиқол",
      "Ҷамъи гирифтани маблағҳои дастаи сатҳи 3",
      "Синф",
      "Волидайн",
      "Даъватшудагон",
      "Рӯйхати корбарон",
      "Ҷамъи корбарон",
      "Барои дидани даста пахш кунед"
    ],
    tabs: [
      "Ҳисоботҳои даста",
      "Дастаи ман"
    ],
    team: [
      "Сатҳ 1",
      "Сатҳ 2",
      "Сатҳ 3"
    ],
    totalUser: "Ҷамъи корбарон",
    clickViewTeam: "Барои дидани даста пахш кунед"
  },
  help: [
    "Дастури кӯмак",
    "Дастрас нест"
  ],
  message: [
    "Паёмро бинед",
    "Паём нест"
  ],
  credit: [
    "Арзёбии даста",
    "Эзоҳи қарзӣ",
    "Сабтҳои қарзӣ",
    "<p>Арзёбии даста ибтидоӣ 60 хол аст.</p><p>1: Агар холҳо камтар аз 50 бошанд, миқдори таҳвили ҳаррӯза ду баробар кам карда мешавад.</p><p>2: Холҳо камтар аз 30 хол мебошанд ва кори таҳвили ҳаррӯзаро анҷом додан мумкин нест.</p><p>3: Агар холҳо камтар аз 10 хол бошанд, шумо наметавонед барои гирифтани пули нақд муроҷиат кунед.</p><p>Қоидаҳои мукофоти холҳо: Баланд бардоштани сатҳи кор 5 хол ва даъват кардани зердастон барои (кормандони расмӣ) шудан 1 хол илова мекунанд.</p><p>Муносибати манфии корӣ, иҷро накардани саривақтии таҳвил ва вайрон кардани қоидаҳои ширкат ба холҳои қарзии шахс таъсир мерасонад.</p>",
    "Холи қарзии ман",
    "Ҳоло сабти қарзӣ вуҷуд надорад"
  ],
  dialog: [
    "Маслиҳатҳо",
    "Тасдиқ",

    "Фиристодан...",

    "Нусхабардорӣ бомуваффақият анҷом ёфт",
    "Версияи системаи IOS паст аст ва дастгирӣ намешавад",

    "Бақайдгирӣ...",

    "Маълумот бор карда мешавад..."
  ],
  lineList: [
    "Интихоби хат",
    "Хати ҷорӣ",

    "Хат"
  ],
  serviceCenter: [
    "Хизматрасонӣ ба мизоҷон",
    "Салом, хизматрасонии истисноии муштариён",

    "Хурсандам, ки ба шумо хизмат мерасонам.",
    "Худхизматрасонӣ",
    "Хизматрасонии онлайн ба мизоҷон",
    "Хизматрасонии муштариёнро пур кунед",
    "Хизматрасонии хатӣ ба мизоҷон"
  ],
  direct: [
    'SGM.s',
    'Бонуси афзоиш',

    'Тавсифи фаъолият',

    '<p>Пас аз даъвати мустақими аъзоён барои ҳамроҳ шудан ба сатҳи VIP, шумо метавонед мукофотҳои пулӣ гиред, агар шумо шартҳоро иҷро кунед!</p><p>Масалан: агар шумо 3 узви сатҳи VIP-ро ба таври умумӣ даъват кунед, шумо метавонед мустақиман мукофот гиред. Пас аз гирифтани он, ба ноил шудан ба ҳадафҳои дигар идома диҳед ва гирифтани онро идома диҳед.</p><p>Мукофоти афзоиши истисноии SGM.s, ҳар як мукофотро ҳар як корманд танҳо як маротиба гирифта метавонад.</p>',
    'Шумораи зердастон',
    'Ба анҷом расонида шавад',
    'Имтиёзҳои даъват',

    'Мукофот гиред',

    'Гирифтани мукофотҳо',
    'Гирифтан'
  ],
  activity: [
    'Педали амалҳо',
    'Тафсилот',

    'Хайрия',

    'Бақияи ҳисоб',

    'Ҳама',

    'Пардохт',

    'Лутфан маблағи хайрияро ворид кунед',

    'Ташаккур барои хайрияатон'
  ],
  apply: {
    awardsTitle: "Мукофотҳо",
    awardsContent: "Мукофотҳо",
    pickUpVehicles: "Гирифтани {count} нақлиёт"
  },
  positions: {
    info: ['Тафсилоти вазифа', 'Ариза барои вазифа', 'Вазифа', 'Кормандони доимии сатҳи G-гурӯҳи сатҳи 3', 'Таносуби аъзои дастаи сатҳи сеюм', 'Музди меҳнати ин моҳ', 'Ҳисоби музди меҳнат', 'Анҷомёфта', 'Бояд пур карда шавад', 'Гирифта шуд', 'Вақти гирифтани музди меҳнат'],
    job: ['Барои баррасӣ пешниҳод кунед', 'Дар ҳоли баррасӣ', 'Баррасӣ шудааст', 'Лутфан ҳуҷҷатҳои дахлдори худро бор кунед', 'Шарҳҳо', 'Барои интихоб ва бор кардани акси шиносномаи худ ба расм клик кунед. ', 'Лутфан акси пеши корти шиносномаи худро дар акси А бор кунед. ', 'Лутфан акси пушти корти шиносномаи худро дар акси Б бор кунед. ', 'Лутфан акси худро дар акси С бо худ бор кунед. ', 'Акси А', 'Акси Б', 'Акси С', 'Лутфан вазифаеро интихоб кунед, ки мехоҳед ба он пешбарӣ шавед', 'Вазифа', 'Музди асосӣ', 'Мукофотпулии иловагӣ', 'Огоҳӣ ба кормандон', 'Ман мундариҷаи Дастурҳои дархости вазифа-ро хондам ва бо онҳо розӣ ҳастам', 'Пешниҳоди дархости вазифа', 'Лутфан вазифаро интихоб кунед', 'Лутфан акси А-ро интихоб кунед', 'Лутфан акси Б-ро интихоб кунед', 'Лутфан акси С-ро интихоб кунед','Лутфан, селфии худро бо корти шахсияти худ дар акси C бор кунед.']
  },
  videoGuide: {
    title: 'Дарси видеоӣ',
    brochure: 'Брошюра',
    description: 'Бо суръат гирифтани раванди урбанизатсияи ҷаҳонӣ, тамбашавии воситаҳои нақлиёт ва тағйирёбии иқлим ба мушкилоти муҳими муштараки ҷаҳон табдил ёфтаанд. Аз ин рӯ, тарзи ҳаракати камкарбон, самаранок ва зеҳнӣ (смарт) ба самти асосии рушди шаҳрҳои оянда табдил меёбад. Дар ин заминаи таърихӣ, ширкати Smart Green Mobility Share Inc. (кӯтоҳ: SGM.S) соли 2023 дар ИМА таъсис ёфта, мақсад дорад, ки платформаи пешбарандаи ҷаҳониро дар соҳаи микро-ҳаракати муштарак (shared micro-mobility) бунёд кунад ва тавассути технологияҳои сабз рушди нақлиёти шаҳриро суръат бахшад.\n\nSGM.S ба хидматрасонии иҷораи дучархаҳои муштарак тамаркуз карда, ба принсипҳои "муштарак, зеҳнӣ ва карбони сифрӣ" устувор аст. Ширкат тавассути инноватсияҳои пайваста ва тавсеаи ҷаҳонӣ, шабакаи қулай, самаранок ва устувори ҳаракати сабзро таъсис медиҳад. Дар айни замон, фаъолияти ширкат беш аз 30 кишвару минтақаро дар панҷ қитъаи ҷаҳон фаро гирифта, дар зиёда аз 280 шаҳр беш аз 300,000 дучархаҳои барқӣ (электробайкҳо) ва скутерҳои барқии муштаракро ҷойгир кардааст. Ширкат ба зиёда аз 8 миллион корбар дар саросари ҷаҳон хидмат расонида, шумораи сафарҳои ҳамарӯзаи сабзи он ба 250,000 маротиба мерасад.\n\nҲамчун яке аз тарҳҳои муҳими стратегии рушди ҷаҳонӣ, SGM.S бозори Тоҷикистонро фаъолона васеъ мекунад. Ширкат тавассути модели ҳаракати барқии муштарак ба сохтмони нақлиёти сабзи маҳаллӣ мусоидат намуда, ба рушди шаҳрҳо нерӯи устувор мебахшад.\n\nSGM.S бо такя ба технологияҳои Интернети ашё (IoT) ва зеҳни сунъӣ (AI) назорати воқеии воситаҳои нақлиёт, банақшагирии зеҳнӣ ва идоракунии пешгӯишавандаи талаботро амалӣ месозад. Ин самаранокии истифодаи воситаҳои нақлиётро ба таври назаррас афзоиш дода, исрофи энергия ва партовҳои карбони амалиётиро коҳиш медиҳад. Ширкат нақша дорад, ки то соли 2026 дар амалиёти худ пурра аз энергияи таҷдидшаванда истифода барад ва то соли 2030 ба ҳадафи партовҳои холиси сифрӣ (Net-Zero) ноил гардад.\n\nДар айни замон, SGM.S ба масъулияти иҷтимоӣ таваҷҷӯҳи зиёд зоҳир мекунад. Дар бозорҳое ба монанди Тоҷикистон, ширкат зиёда аз 200,000 ҷойҳои корӣ дар соҳаҳои амалиёт, технология, хидматрасонии мизоҷон ва ғайра таъсис дода, ба рушди занҷири таъминоти маҳаллӣ ва иқтисодиёти минтақавӣ мусоидат намудааст. Ҳамзамон, ширкат дар лоиҳаҳои хайриявӣ, аз қабили дастгирии маориф ва кӯмакҳои тиббӣ фаъолона иштирок карда, ба ҳамгироии ҳаракати муштарак ва арзишҳои иҷтимоӣ пайваста замина мегузорад.\n\nАз ҷониби дигар, SGM.S нақшаи онлайнии ҷойгиркунии воситаҳои нақлиётро роҳандозӣ кардааст. Корбарон метавонанд тавассути замимаи мобилӣ дар тақсимоти захираҳои парк ва амалиёти муштараки воситаҳои нақлиёт иштирок кунанд. Ин имкон медиҳад, ки рушди платформа ва арзиши корбарон ба таври муштарак баҳравар шаванд ва якҷоя ба иқтисодиёти сабз ва ояндаи устувор мусоидат намоянд.\n\nSGM.S — пешсафи ҳаракати барқии муштарак, суръатбахши гузариши шаҳрҳои ҷаҳон ба низоми камкарбон.'
  },
}